<template lang="pug">
  aiq-time-picker(
    v-bind="$attrs"
    v-on="$listeners"
    v-model="internalValue"
    :format="formatting"
    :range-separator="rangeSeparator"
    :popper-class="mergedPopperClass"
    @change="emitFinal"
  )
</template>

<script>

export default {
  name: 'ConfirmableTimePicker',
  props: {
    modelValue: {
      type: [String, Date, Array],
      default: null,
    },
    popperClass: {
      type: String,
      default: '',
    },
    formatting: {
      type: String,
      default: 'hh:mm A',
    },
    rangeSeparator: {
      type: String,
      default: '-',
    },
  },
  computed: {
    mergedPopperClass() {
      return this.popperClass.includes('final-time-picker-popover')
        ? this.popperClass
        : `${this.popperClass} final-time-picker-popover`.trim();
    },
  },
  emits: ['change'],
  data() {
    return {
      internalValue: this.modelValue,
    };
  },
  watch: {
    modelValue(val) {
      this.internalValue = val;
    },
  },
  methods: {
    emitFinal(val) {
      this.$emit('change', val);
    },
  },
};
</script>

<style lang="scss">
  .final-time-picker-popover .el-time-panel__content:before {
    border-bottom: none;
    border-top: none;
    margin-left: 0;
  }
  .final-time-picker-popover .el-time-panel__content:after {
    margin-right: 0;
  }
</style>
